import React from "react";
import {CALENDER_ICON, ACCOUNT_ICON } from "assets/constants/Icons";
import moment from 'moment';
import { Box } from "@material-ui/core";

const Account = () => {
  return (<>
    {
       (
        <Box className="main-content">
          <Box className="pagetitle row" style={{ color: 'black', paddingTop: 15 }}>
            <Box className="col-md-10 sm_device"><i className={`${ACCOUNT_ICON}`}></i> Account</Box>
            <Box className="col-md-2 sm_device" style={{ textAlign: 'right' }}><i className={`${CALENDER_ICON}`}></i> {moment().format("DD MMM YYYY")}</Box>
          </Box>
          <Box style={{ borderBottom: '1px solid lightgray', marginBottom: 15, marginTop: 15 }} />
          <Box className="list-wrapper">
          GenAI is changing the world, one domain at a time, whats yours?"
            
          </Box>
        </Box>
      )
    }
  </>);
}

export default Account;